var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 28,
    rx: 4,
    fill: "#4285F4",
    fillOpacity: 0.18000000715255737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8448,0.630263Q2.27001,0.358311,2.74945,0.200511Q3.22888,0.0427105,3.73249,0.00895511L3.79937,1.00672Q3.03173,1.05817,2.3836,1.4727L1.8448,0.630263ZM0,4L1,4Q1,3.23392,1.3673,2.56163L0.489736,2.08218Q0.248735,2.52329,0.124368,3.01032Q0,3.49734,0,4ZM0,8L0,6L1,6L1,8L0,8ZM0,12L0,10L1,10L1,12L0,12ZM0,16L0,14L1,14L1,16L0,16ZM0,20L0,18L1,18L1,20L0,20ZM0.147293,25.0755Q7.03923e-16,24.5478,0,24L0,22L1,22L1,24Q1,24.4109,1.11047,24.8066L0.147293,25.0755ZM2.83903,27.8278Q2.35603,27.6813,1.92457,27.4194Q1.4931,27.1576,1.14021,26.7967L1.85515,26.0975Q2.39306,26.6476,3.12928,26.8709L2.83903,27.8278ZM6.81911,28L4.81911,28L4.81911,27L6.81911,27L6.81911,28ZM10.8191,28L8.81911,28L8.81911,27L10.8191,27L10.8191,28ZM14.5942,27.0447Q14.2107,27.3714,13.7582,27.5929Q13.3058,27.8143,12.8125,27.9166L12.6094,26.9375Q13.3612,26.7815,13.9456,26.2835L14.5942,27.0447ZM16,23.4539L16,24Q16,24.7356,15.7383,25.4231L14.8037,25.0673Q15,24.5517,15,24L15,23.4539L16,23.4539ZM16,19.4539L16,21.4539L15,21.4539L15,19.4539L16,19.4539ZM16,15.4539L16,17.4539L15,17.4539L15,15.4539L16,15.4539ZM16,11.4539L16,13.4539L15,13.4539L15,11.4539L16,11.4539ZM16,7.45393L16,9.45393L15,9.45393L15,7.45393L16,7.45393ZM15.9633,3.45935Q16,3.72843,16,4L16,5.45393L15,5.45393L15,4Q15,3.79632,14.9725,3.59451L15.9633,3.45935ZM13.6738,0.367038Q14.1319,0.57812,14.5234,0.896341Q14.9148,1.21456,15.2149,1.61999L14.4112,2.21499Q13.9537,1.59702,13.2553,1.27528L13.6738,0.367038ZM9.72696,0L11.727,0L11.727,1L9.72696,1L9.72696,0ZM7.72696,0L7.72696,1L5.72696,1L5.72696,0L7.72696,0Z",
    fillRule: "evenodd",
    fill: "#4285F4",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecond);
export default __webpack_public_path__ + "static/media/icon-second.9acdc3a5a71c52cdc493642f138b76db.svg";
export { ForwardRef as ReactComponent };